import { popperTriggerProps as o } from "./index561.js";
import { buildProps as p, definePropType as e } from "./index601.js";
import { EVENT_CODE as r } from "./index590.js";
const g = p({
  ...o,
  /**
   * @description whether Tooltip is disabled
   */
  disabled: Boolean,
  /**
   * @description How should the tooltip be triggered (to show), not valid in controlled mode
   */
  trigger: {
    type: e([String, Array]),
    default: "hover"
  },
  /**
   * @description When you click the mouse to focus on the trigger element, you can define a set of keyboard codes to control the display of tooltip through the keyboard, not valid in controlled mode
   */
  triggerKeys: {
    type: e(Array),
    default: () => [r.enter, r.numpadEnter, r.space]
  },
  /**
   * @description when triggering tooltips through hover, whether to focus the trigger element, which improves accessibility
   */
  focusOnTarget: Boolean
});
export {
  g as useTooltipTriggerProps
};
